export default __webpack_public_path__ + "static/media/roasted-bowl.950b268c.svg";